<ion-content>
    <ion-router-outlet></ion-router-outlet>
</ion-content>
<app-dashboard-footer></app-dashboard-footer>
